<template>
  <div class="multiform">
    <div
      ref="multiformContainer"
      class="multiform__container"
      :class="{ 'is-single-item': max <= 1 }"
    >
      <multi-form-items :repeat="max">
        <div class="multiform-item">
          <div class="content">
            <slot></slot>
          </div>

          <div class="item-remove" @click="removeMultiformSection">
            <span class="multiform__icon">
              <dotcom-icon name="trash" art="light" />
            </span>
          </div>
        </div>
      </multi-form-items>
    </div>
    <div class="multiform__iconLink" @click="addMultiformSection">
      <span class="multiform__icon">
        <dotcom-icon name="plus" art="light" />
      </span>
      <span>{{ label }}</span>
    </div>
  </div>
</template>

<script>
import MultiFormItems from './MultiFormItems'

export default {
  name: 'SanMultiForm',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
    MultiFormItems,
  },
  props: {
    label: {
      type: String,
      default: 'Add additional Person',
    },
    isMulti: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    max: 1,
  }),
  methods: {
    addMultiformSection() {
      this.max++
    },
    removeMultiformSection() {
      if (this.max > 1) {
        this.max--
      }
    },
  },
}
</script>

<style scoped>
.multiform__container.is-single-item {
  .multiform-item {
    min-height: inherit;
    padding-bottom: 20px;

    .item-remove {
      display: none;
    }
  }
}

.multiform__icon {
  position: relative;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--c-secondary-neutral-2);

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 1px solid var(--c-secondary-neutral-2);
  }
}

.multiform-item {
  position: relative;
  border: 1px solid var(--c-secondary-neutral-3);
  border-radius: 12px;
  margin-bottom: var(--spacing-6);
  min-height: 200px;
  padding: 0 30px;

  .item-remove {
    position: absolute;
    right: var(--spacing-4);
    top: var(--spacing-4);
    justify-content: center;
    color: var(--c-secondary-neutral-2);
    cursor: pointer;
  }
}

.multiform__iconLink,
.item-remove {
  &:hover {
    span:last-child,
    .multiform__icon {
      color: var(--c-tint-color-1);
    }

    .multiform__icon::after {
      border-color: var(--c-tint-color-1);
    }
  }
}

.multiform__iconLink {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: var(--spacing-2);

  span:last-child {
    font-size: 15px;
    line-height: 24px;
  }
}

@media (--md) {
  .multiform-item {
    padding: 0 80px 15px 30px;
    min-height: inherit;
  }

  .item-remove {
    right: var(--spacing-6);
    top: var(--spacing-6);
  }
}
</style>
